module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (98).5a6906b5.jpg";